<template>
    <div class="request-panel">
        <div class="request-panel__head">
            <h2 class="request-panel__title">{{ title }}</h2>
            <div v-if="$slots.actions" class="request-panel__actions">
                <slot name="actions" />
            </div>
        </div>
        <div v-if="$slots.default" class="request-panel__filters">
            <slot />
        </div>
    </div>
</template>

<script>
// Boxed header matching RequestYearToolbar, for pages that keep their own filter controls (admin)
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.request-panel {
    margin: 12px 0 20px;
    padding: 28px 32px;
    border: 1px solid #e8eaec;
    border-radius: 4px;
    background: #fff;

    &__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 16px;
    }

    &__title {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #211841;
    }

    &__actions {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
    }

    &__filters {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-top: 20px;
    }
}

@media screen and (max-width: 767px) {
    .request-panel {
        padding: 16px;

        &__title {
            font-size: 20px;
        }

        &__actions {
            width: 100%;
        }
    }
}
</style>

<style lang="scss">
// Unscoped: slotted filter controls carry the parent's scope id, not this component's
.request-panel__filters > * {
    flex: 0 1 220px;
    min-width: 180px;
}

@media screen and (max-width: 767px) {
    .request-panel__filters > * {
        flex: 1 1 100%;
    }
}
</style>
